/**
 * SectionBackground - Reusable section background component
 * Provides consistent gradient background across all sections
 */

import { useIsMobile } from "@/hooks/use-mobile";

interface SectionBackgroundProps {
  variant?: 'default' | 'subtle' | 'intense';
  className?: string;
}

const SectionBackground = ({ 
  variant = 'default',
  className = '' 
}: SectionBackgroundProps) => {
  const isMobile = useIsMobile();
  
  // Disable dark overlay gradients on mobile
  if (isMobile) {
    return null;
  }
  
  const gradients = {
    default: 'bg-gradient-to-b from-transparent via-background/50 to-transparent',
    subtle: 'bg-gradient-to-b from-transparent via-background/30 to-transparent',
    intense: 'bg-gradient-to-b from-transparent via-background/70 to-transparent',
  };

  return (
    <div 
      className={`absolute inset-0 ${gradients[variant]} ${className}`}
      aria-hidden="true"
    />
  );
};

export default SectionBackground;





